import Twitter from '@components/icons/Twitter'
import Facebook from '@material-ui/icons/Facebook'
import Instagram from '@material-ui/icons/Instagram'
import Linkedin from '@material-ui/icons/LinkedIn'
import React from 'react'

const MenuItemIcon = ({ icon, size = 40 }: { icon?: string; size?: number }) => {
  switch (icon) {
    case 'facebook':
      return <Facebook style={{ fontSize: size }} />
    case 'twitter':
      return <Twitter style={{ fontSize: '26px' }} />
    case 'X':
      return <Twitter style={{ fontSize: '26px' }} />
    case 'instagram':
      return <Instagram style={{ fontSize: size }} />
    case 'linkedin':
      return <Linkedin style={{ fontSize: size }} />
    default:
      return <></>
  }
}

export default MenuItemIcon
